import ShipmentCreatePage from "./ShipmentCreatePage";
export default ShipmentCreatePage;
